import { TReduxActions } from '../../types/redux';
import { IComparisonState } from '../../types/redux/comparison';
import { ELoadingStatus } from '../../types/redux/loadingStatus';
import { ECompareTypeActionTypes, EGetComparisonStatus } from '../../actions/compare';

const defaultState: IComparisonState = {
  status: {
    default: ELoadingStatus.Initial,
    differences: ELoadingStatus.Initial,
  },
  compareType: 'default',
};

export function comparisonReducer(state: IComparisonState = defaultState, action: TReduxActions): IComparisonState {
  switch (action.type) {
    case ECompareTypeActionTypes.SetCompareType:
      return {
        ...state,
        compareType: action.payload,
      };
    case EGetComparisonStatus.Succeed:
      return {
        ...state,
        status: {
          ...state.status,
          [action.payload.compareType]: ELoadingStatus.Succeed,
        },
      };
    case EGetComparisonStatus.Failed:
      return {
        ...state,
        status: {
          ...state.status,
          [action.payload]: ELoadingStatus.Failed,
        },
      };
    case EGetComparisonStatus.Loading:
      return {
        ...state,
        status: {
          ...state.status,
          [action.payload]: ELoadingStatus.Loading,
        },
      };
    default:
      return state;
  }
}
